import { SpiderOutlineIcon } from './SpiderOutlineIcon';

/**
 * author: Jeff Anders
 * id 52BB8EB9-6227-4EFD-BEFF-F20BE1670AEC
 * name spider-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/spider-outline.svg
 * tags
 * - Animal 
 * - Holiday 
 * - Nature 
 */
export const ArachnidOutlineIcon = SpiderOutlineIcon;
export default ArachnidOutlineIcon